var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.121,
    height: 69.121,
    viewBox: "0 0 69.121 69.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_10_1",
    "data-name": "Componente 10 \\u2013 1",
    transform: "translate(1.061 1.061)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_6",
    "data-name": "L\\xEDnea 6",
    x2: 67,
    y2: 67,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_7",
    "data-name": "L\\xEDnea 7",
    x1: 67,
    y2: 67,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseWhite);
export default __webpack_public_path__ + "static/media/ic_close_white.b9dee1311705086a5424b806429f29cd.svg";
export { ForwardRef as ReactComponent };